import {
  PERIOD_TO_HOURS,
  PERIOD_TO_LINES,
} from "./constants";
import { getIndexes } from "./utils";
import * as d3 from 'd3';

/**************************************************
 * Validate IPs
 **************************************************/
export const validateIPv4IPv6 = (address) => {
  const ipv46_regex =
    /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/gm;

  return ipv46_regex.test(address);
};

export const validateIPv4 = (address) => {
  const ipv4_regex =
    /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$/gm;

  return ipv4_regex.test(address);
};

export const validateIPv6 = (address) => {
  const ipv6_regex =
    /^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$/gm;

  return ipv6_regex.test(address);
};

export const validateIPv4WithMask = (address) => {
  const ipv4_regex =
    /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$/gm;

  return ipv4_regex.test(address);
};

export const validateIPv6WithMask = (address) => {
  const ipv6_regex =
    /^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?(\/([1-9]|[0-9][0-9]|1[0-2][0-8]))?$/gm;

  return ipv6_regex.test(address);
};

export const validateIPv4IPv6WithMask = (address) =>
  validateIPv4WithMask(address) || validateIPv6WithMask(address);

export const isIPv4IPv6Range = (input) =>
  input.search(/\/.*$/) !== -1 && validateIPv4IPv6Range(input);

export const validateIPv4IPv6Range = (input) =>
  validateIPv4IPv6(input.replace(/\/.*$/, ""));

export const isValidIPValue = (value) =>
  value.length === 0 || validateIPv4WithMask(value) || validateIPv6WithMask(value);

export const parseNames = (input) => {
  const [_head, ...lines] = input.trim().split("\n");
  const names = lines.map((line) => line.replace(/\s.*$/, ""));
  return { names };
};

export const parseColumnValues = (input, indexes, limit) => {
  const result = [];
  const [_head, ...lines] = input.trim().split("\n");
  let finishedCount = 0;
  let finished = {};
  for (let line of lines) {
    const words = line.split(/\s+/);
    for (let index of indexes) {
      if (!result[index]) {
        result[index] = new Set([words[index]]);
      } else if (!limit || result[index].size < limit) {
        result[index].add(words[index]);
      }

      if (result[index].size === limit && !finished[index]) {
        finished[index] = true;
        finishedCount++;
      }
    }

    if (finishedCount === indexes.length) {
      break;
    }
  }

  return result;
};

export const getIPv6Prefix = () =>
  ifCl.run("show subscriber ipv6-prefix").then((resp) => resp.trim());
// This promise will be kept resolved for next calls.

const expressIPv6Addr = (addr, ipv6Mask = true) =>
  ipv6Mask !== true
    ? Promise.resolve(addr)
    : getIPv6Prefix().then(
        (ipv6prefix) => `${addr}/${ipv6prefix}`
      ); /*IPv6 missing prefix*/

const addsKeyword = (addressKeyword = null) =>
  addressKeyword === null
    ? (result) => result
    : (result) => `${addressKeyword} ${result}`;

export const expressedAddr = (
  addr,
  { ipv6Mask = true, addressKeyword = null }
) =>
  addr.includes(":") && addr.match(/\/\d+$/) === null
    ? expressIPv6Addr(addr, ipv6Mask).then(addsKeyword(addressKeyword))
    : addsKeyword(addressKeyword)(addr);

const quoteWrap = input => `'${input}'`;

const allSpecialSymbols = /[#"'|\\]/g;
const escapedSymbol = '\\$&';

export const safeStrUnderscore = input =>
  input
    .trim()
    .replace(/\s/g, "_")
    .replace(allSpecialSymbols, escapedSymbol);

const safeStrKeepSpaces = input =>
  input
    .replace(allSpecialSymbols, escapedSymbol);

const _SAFE_STR_DEFAULTS = {
  preserveSpaces: false,
};

export const safeStr = (input, options = _SAFE_STR_DEFAULTS) =>
  quoteWrap(
    options.preserveSpaces === true
      ? safeStrKeepSpaces(String(input))
      : safeStrUnderscore(String(input))
  );


export const csvName = (input) => `"${input.replaceAll("\\", "\\\\").replaceAll('"', '""').replaceAll("'", "\\'").replace(/\s+/g, '')}"`;

export const safeSubsId = input => safeStr(input);

const _default_options = {
  subsIdKeyword: "id",
  ipv6Mask: true,
  addressKeyword: null,
  noTarget: "all",
};

export const expressTarget = (
  { addr = null, subsId = null },
  options = _default_options
) => {
  const { subsIdKeyword = "id" } = options;
  return Promise.resolve(
    addr !== null && addr.startsWith("id ") === false
      ? expressedAddr(addr, options)
      : subsId !== null
      ? `${subsIdKeyword} ${safeSubsId(subsId)}`
      : options.noTarget || "all"
  );
};

export const parsePoliciesIntoSets = (response) => {
  const lines = response.trim().split("\n");
  const [_head, ...rows] = lines;
  return rows.reduce(mergeIntoSets, initialPolicySets());
};

const mergeIntoSets = ({ types, sources }, row) => {
  const [name, type, source] = row.split(/\s+/);
  types = {
    ...types,
    [type]: type in types ? types[type].add(name) : new Set([name]),
  };
  sources = {
    ...sources,
    [source]: source in sources ? sources[source].add(name) : new Set([name]),
  };
  return { sources, types };
};

const initialPolicySets = () => ({
  types: { rate: new Set(), flow: new Set() },
  sources: { static: new Set() },
});

export const parseSystemDate = (input) =>
  new Date(input.replace(/(\+|-)[0-9]+/, ""));

export const doSystemDateRetrieval = () => ifCl.run("show system date");

export const calcRangeExtent = (end, hours) => {
  const start = new Date(end.getTime() - hours * 3600 * 1000);
  return { from: start, to: end };
};

export const retrieveRange = (hours) =>
  doSystemDateRetrieval()
    .then(parseSystemDate)
    .then((now) => calcRangeExtent(now, hours));

export function getSystemDate() {
  return ifCl.run("show system date");
}

const parseStatementItem = (row) => {
  const [bqn, type, status, _updates, timeStr] = row.trim().split(/\s+/);
  return {
    bqn,
    type,
    status,
    time: new Date(timeStr),
  };
};
const involvedStatementsRE = /license-(available|expiration)/;
const parseLicenseStatements = (input) => {
  const lines = input.trim().split("\n");
  const [_head, ...rows] = lines;
  return rows
    .filter((row) => row.match(involvedStatementsRE))
    .map(parseStatementItem);
};
const checkLicenseStatus = (statements) => statements.filter(({ status, type }) => status === "normal");

const handleStatementRejectionError = (warn) => (error) => {
  if (String(error).startsWith("License statement")) {
    if (warn === true) {
      console.warn("rejected due to:", error);
    }
    return false; // not valid;
  }
  console.error(error);
  throw error;
};

export const checkLicense = (input, warn = true) =>
  Promise.resolve(parseLicenseStatements(input))
    .then((res) => checkLicenseStatus(res))
    .then((statements) => statements.length >= 2)
    .catch(handleStatementRejectionError(warn));

const securityFieldTranslations = {
  "Access lock failures": "maxFailures",
  "Access unlock time": "unlockTime",
  "Password minlen": "passwordMinLength",
  "Password lcredit": "passwordLCredit",
  "Password ucredit": "passwordUCredit",
  "Password dcredit": "passwordDCredit",
  "Password ocredit": "passwordOCredit",
  "Password enforce for root": "enforceRoot",
  "Password reject username": "enforceUsername",
};

const asSecurityFieldValue = (row) => {
  const [fieldStr, valueStr] = row.split(/:\s+/);
  const field = securityFieldTranslations[fieldStr] || fieldStr;
  const value =
    valueStr === "n/a"
      ? null
      : valueStr === "yes"
      ? true
      : valueStr === "no"
      ? false
      : parseInt(valueStr);
  return [field, value];
};

const intoSecuritySettings = (settings, [field, value]) => ({
  ...settings,
  [field]: value,
});

const _SECURITY_DEFAULTS = {
  maxFailures: 0,
  unlockTime: 0,
  passwordMinLength: 0,
  passwordLCredit: 0,
  passwordUCredit: 0,
  passwordDCredit: 0,
  passwordOCredit: 0,
  enforceRoot: false,
  enforceUsername: false,
};

export const parseSystemSecurity = (response) =>
  response
    .trim()
    .split("\n")
    .map(asSecurityFieldValue)
    .reduce(intoSecuritySettings, _SECURITY_DEFAULTS);

const notNAAndHigherOrEqualTo = (threshold) => (value) =>
  value !== null && value >= threshold;
const notNAAndLowerOrEqualTo = (threshold) => (value) =>
  value !== null && value <= threshold;
const validCredit = notNAAndLowerOrEqualTo(-1);

export const checkSystemSecurityActive = ({
  maxFailures,
  unlockTime,
  passwordMinLength,
  passwordLCredit,
  passwordUCredit,
  passwordDCredit,
  passwordOCredit,
  enforceUsername,
  enforceRoot,
}) =>
  notNAAndHigherOrEqualTo(4)(maxFailures) &&
  notNAAndHigherOrEqualTo(300)(unlockTime) &&
  notNAAndHigherOrEqualTo(9)(passwordMinLength) &&
  validCredit(passwordLCredit) &&
  validCredit(passwordDCredit) &&
  validCredit(passwordOCredit) &&
  validCredit(passwordUCredit) &&
  enforceRoot === true &&
  enforceUsername === true;

const notAllowedUsernames = new Set(['admin', 'administrator','administration', 'root', 'system']);

export const validUsername = (username = '') => {
  if (notAllowedUsernames.has(username.toLowerCase())) {
    throw `${username} is not an allowed username`
  }
  if (username.length < 5) {
    throw 'Minimun user name length is 5 characters';
  }
  if (username.length > 5) {
    throw 'Maximum user name length is 16 characters';
  }
  return username
}

export const securityIsStrict = (params) => {
  if (checkSystemSecurityActive(params) !== true) {
    throw 'Strict security not enabled';
  }
  return params
}


export function getSampleSize(range, POINTS_PER_TILE_CHART, period){
  if(!range){
    return 1;
  }
  const {from, to} =range;
  const begin = new Date(from)
  const end = new Date(to)
  const timeDiffinHours = (end.getTime()- begin.getTime()) / (1000*60*60);
  const lines = (timeDiffinHours / PERIOD_TO_HOURS[period])*PERIOD_TO_LINES[period]
  const sampleSize = Math.floor(lines/POINTS_PER_TILE_CHART) + 1;
  return sampleSize;
};

export const isInsideRange =
  ({ from, to }, field = "time") =>
  (item) =>
    from <= item[field] && item[field] <= to;


export const getMeanValue = (values) => {
  if (!values) {
    return "n/a";
  }
  const sum = values.reduce((acc, value)=> {
    acc = acc + value;
    return acc;
    }, 0)
    
  return sum/values.length;
}

export function getDateWithOffset(timeOffset) {
  const now = new Date();
  now.setHours(now.getHours() + timeOffset);
  now.setMilliseconds(500);
  return now;
}

export function capitalize(str) {
  return str.charAt(0).toUpperCase()+str.slice(1);
};

const clusterStatusTranslations = {
  "Mode": "mode",
  "BQN ID": "bqnId",
  "State": "state",
  "Status": "status",
  "Total BQNs": "total",
  "Online BQNs": "online",
  "Primary BQN": "primary",
  "Minimum BQN": "minimum",
  "Maximum BQN": "maximum",
}

export function parseClusterStatusResponse(response) {
  const output = {};
  const lines = response.trim().split("\n");
  for (const line of lines) {
    const [label, value] = line.split(":");
    output[clusterStatusTranslations[label]] = value.trim();
  }
  return output;
}
export const getClusterStatus = () =>
  ifCl.run("show cluster status")
    .then(parseClusterStatusResponse)
    .catch( error => console.warn(error) || null );

export class NothingToDo extends Error {}

export const areChanges = (command) =>
  command !== undefined && command !== null && command.length > 0;

export const cliCommand =
  (strings, ...values) =>
  (enter = true) =>
    String.raw({ raw: strings }, ...values)
      .replace(/^\n+\s+/g, "")
      .replace(/\n\n/g, "\n")
      .replace(/\n\s+/g, "\n")
      .concat(enter ? "\n" : "");

export const invalid = (reason) => {
  throw reason;
};

const wrapIntoBlock = (
  commands = [],
  { start = null, end = null, enter = false }
) => [
  ...(start === null ? [] : [start]),
  ...(Array.isArray(commands) ? commands.flat() : [commands]),
  ...(end === null ? [] : [end]),
  ...(enter ? [""] : []),
];

export const block =
  ({ optional = false, ...settings }) =>
  (commands = []) =>
    (commands.length > 0 && commands.some(areChanges) === true)
      ? wrapIntoBlock(commands, settings || {})
      : optional === false
      ? invalid(new NothingToDo())
      : [];

export function debounce(fn, ms) {
  let timer;
  return (_) => {
    clearTimeout(timer);
    timer = setTimeout((_) => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

/**
 * 
 * @param {*} input 
 * Example
`BQN ID:          241
optimization:    enabled
compression:     disabled
dpi:             enabled
dpi-per-user:    enabled
rate-limit:      enabled

BQN ID:          242
optimization:    disabled
compression:     disabled
dpi:             disabled
dpi-per-user:    disabled
rate-limit:      disabled

`
 */
export function splitClusterKeyValuesResponse(input){
  const responses = input.trim().split('\n\n')
  const output = [];
  for(const response of responses){
    const bqnIdRegex = /BQN ID:\s+(\d+)\n/;
    const match = response.match(bqnIdRegex)
    if(match){
      const resp = response.replace(bqnIdRegex, '')
      output.push({bqnId: match[1], resp})
    }
  }

  return output;
}

/**
     * 
     * @param {*} input 
     * Example Cluster mode:
BQN ID 241:
  Filesystem      Size  Used Avail Use% Mounted on
  devtmpfs        2.0G   40K  2.0G   1% /dev
  tmpfs           2.0G     0  2.0G   0% /dev/shm
  tmpfs           2.0G   25M  1.9G   2% /run
  /dev/sda2        61G  1.4G   57G   3% /
  /dev/loop0      2.4M  2.4M     0 100% /bqn/img/bqnos
  /dev/loop1      240M  240M     0 100% /bqn/img/linux
  /dev/loop2       39M   39M     0 100% /bqn/img/bqnkernel
  /dev/loop3      243M  243M     0 100% /bqn/img/kernel
  /dev/loop4      1.8M  1.8M     0 100% /bqn/img/gui
  /dev/loop5       37M   37M     0 100% /bqn/img/bqn
  tmpfs           2.0G     0  2.0G   0% /sys/fs/cgroup
  tmpfs           2.0G   25M  1.9G   2% /var/run
BQN 242:
  Filesystem      Size  Used Avail Use% Mounted on
  devtmpfs        2.0G   40K  2.0G   1% /dev
  tmpfs           2.0G     0  2.0G   0% /dev/shm
  tmpfs           2.0G   17M  2.0G   1% /run
  /dev/sda2        61G  1.4G   57G   3% /
  /dev/loop0      2.4M  2.4M     0 100% /bqn/img/bqnos
  /dev/loop1      240M  240M     0 100% /bqn/img/linux
  /dev/loop2       39M   39M     0 100% /bqn/img/bqnkernel
  /dev/loop3      243M  243M     0 100% /bqn/img/kernel
  /dev/loop4      1.8M  1.8M     0 100% /bqn/img/gui
  /dev/loop5       37M   37M     0 100% /bqn/img/bqn
  tmpfs           2.0G     0  2.0G   0% /sys/fs/cgroup
  tmpfs           2.0G   17M  2.0G   1% /var/run

Example Standalone:
Filesystem      Size  Used Avail Use% Mounted on
devtmpfs        2.0G   40K  2.0G   1% /dev
tmpfs           2.0G     0  2.0G   0% /dev/shm
tmpfs           2.0G   17M  2.0G   1% /run
/dev/sda2        61G  1.4G   57G   3% /
/dev/loop0      2.4M  2.4M     0 100% /bqn/img/bqnos
/dev/loop1      240M  240M     0 100% /bqn/img/linux
/dev/loop2       39M   39M     0 100% /bqn/img/bqnkernel
/dev/loop3      243M  243M     0 100% /bqn/img/kernel
/dev/loop4      1.8M  1.8M     0 100% /bqn/img/gui
/dev/loop5       37M   37M     0 100% /bqn/img/bqn
tmpfs           2.0G     0  2.0G   0% /sys/fs/cgroup
tmpfs           2.0G   17M  2.0G   1% /var/run

     * @returns 
     */
export function splitClusterResponse(input){
  const regex =  /BQN (?:ID )?(\d+):\n+/;
  const regexAlt = /BQN ID:\s+(\d+)\n+/
  const output = [];
  let bqnId;
  const parts = input.trim().split(input.search(regex) !== -1 ? regex : regexAlt);
  
  for(const part of parts){
    if(!part){
      continue;
    }

    if(!isNaN(part)){
      bqnId = part;
    }else{
      output.push({bqnId, resp: part.trim()})
    }
  }

  return output;
}


/**
     * 
     * @param {*} input 
     * Example Cluster mode:
BQN ID 241:
  Filesystem      Size  Used Avail Use% Mounted on
  devtmpfs        2.0G   40K  2.0G   1% /dev
  tmpfs           2.0G     0  2.0G   0% /dev/shm
  tmpfs           2.0G   25M  1.9G   2% /run
  /dev/sda2        61G  1.4G   57G   3% /
  /dev/loop0      2.4M  2.4M     0 100% /bqn/img/bqnos
  /dev/loop1      240M  240M     0 100% /bqn/img/linux
  /dev/loop2       39M   39M     0 100% /bqn/img/bqnkernel
  /dev/loop3      243M  243M     0 100% /bqn/img/kernel
  /dev/loop4      1.8M  1.8M     0 100% /bqn/img/gui
  /dev/loop5       37M   37M     0 100% /bqn/img/bqn
  tmpfs           2.0G     0  2.0G   0% /sys/fs/cgroup
  tmpfs           2.0G   25M  1.9G   2% /var/run
BQN 242:
  Filesystem      Size  Used Avail Use% Mounted on
  devtmpfs        2.0G   40K  2.0G   1% /dev
  tmpfs           2.0G     0  2.0G   0% /dev/shm
  tmpfs           2.0G   17M  2.0G   1% /run
  /dev/sda2        61G  1.4G   57G   3% /
  /dev/loop0      2.4M  2.4M     0 100% /bqn/img/bqnos
  /dev/loop1      240M  240M     0 100% /bqn/img/linux
  /dev/loop2       39M   39M     0 100% /bqn/img/bqnkernel
  /dev/loop3      243M  243M     0 100% /bqn/img/kernel
  /dev/loop4      1.8M  1.8M     0 100% /bqn/img/gui
  /dev/loop5       37M   37M     0 100% /bqn/img/bqn
  tmpfs           2.0G     0  2.0G   0% /sys/fs/cgroup
  tmpfs           2.0G   17M  2.0G   1% /var/run

Example Standalone:
Filesystem      Size  Used Avail Use% Mounted on
devtmpfs        2.0G   40K  2.0G   1% /dev
tmpfs           2.0G     0  2.0G   0% /dev/shm
tmpfs           2.0G   17M  2.0G   1% /run
/dev/sda2        61G  1.4G   57G   3% /
/dev/loop0      2.4M  2.4M     0 100% /bqn/img/bqnos
/dev/loop1      240M  240M     0 100% /bqn/img/linux
/dev/loop2       39M   39M     0 100% /bqn/img/bqnkernel
/dev/loop3      243M  243M     0 100% /bqn/img/kernel
/dev/loop4      1.8M  1.8M     0 100% /bqn/img/gui
/dev/loop5       37M   37M     0 100% /bqn/img/bqn
tmpfs           2.0G     0  2.0G   0% /sys/fs/cgroup
tmpfs           2.0G   17M  2.0G   1% /var/run

     * @returns 
     */
export function parseClusterResponse(res, parseFn, bqnId){
  const parts = splitClusterResponse(res);
  const output = {};
  for (const part of parts) {
    output[part.bqnId ?? bqnId ?? "0"] = parseFn(part.resp);
  }
  return output; 
}

export  function isClusterResponse(input){
  return input.startsWith('BQN')
}

/* Standalone response
`
Active number: 3456
Total number: 123
`
Cluster response:
BQN    ACTIVE     TOTAL
241         1         1
Active number: 1
Total number: 1
*/
export function parseShowApiSubscriberGroupStatus(res) {
  let activeNumber = 0;

  if (isClusterResponse(res)) {
    parseStrTable(res, function (attrs, i) {
      if (window.bqnId.toString() === attrs[0]) {
        activeNumber = Number(attrs[1]);
      }
    });
  } else {
    const [_head, ...rows] = res.trim().split("\n");
    activeNumber = Number(_head.split(":")[1]);
  }

  return activeNumber;
}

//
// ParseStrTable
//
export function parseStrTable(strTable, parseLine, skipHdr) {
  // Parameter skipHdr is optional and defaults to true
  var lines = strTable.trim().split('\n'),
    firstLine = ((skipHdr === undefined || skipHdr) ? 1 : 0);
  for (var i = firstLine; i < lines.length; i++) {
    parseLine(lines[i].trim().split(/\s+/), i);
  }
};
const CANT_PROCEED_ERROR =
  "Cannot proceed while there are pending config changes." +
  " Try again later.";

export const checkNothingPending = () =>
  ifCl.run("show config diff").then((response) => {
    if (response.length > 0) {
      throw new Error(CANT_PROCEED_ERROR);
    }
  });


export function isNameValid(str, maxLen) {
    const len = str.length;
    if (len == 0) return false;
    if (maxLen !== undefined && maxLen && len > maxLen) return false;
    return !/[ ?<>!$%&()'\[\]*+]/.test(str);
  };

export function parseHostnames(response) {
  const [header, ...rows] = response.trim().split("\n");
  const headerIndex = getIndexes(header);
  return rows.reduce((acc, value) => {
    const attrs = value.trim().split(/\s+/);
    const bqn = attrs[headerIndex["BQN"]];
    const hostname = attrs[headerIndex["HOSTNAME"]];
    acc[bqn] = hostname;
    return acc;
  }, {});
}

export function parseBqnsAndHostnames(bqnsRes, hostnamesRes) {
  const bqns = parseShowClusterBqn(bqnsRes);
  const hostnames = parseHostnames(hostnamesRes);
  return bqns.map((bqn) => ({ ...bqn, hostname: hostnames[bqn.bqnId] }));
}


  export function parseShowClusterBqn(input) {
    const lines = input.trim().split("\n");
    const [header, ...rows] = lines;
    const headerIndex = getIndexes(header);
    const output = [];

    for (const row of rows) {
      const attrs = row.trim().split(/\s+/);
      output.push({
        bqnId: attrs[headerIndex["BQN"]],
        ipAddress: attrs[headerIndex["ADDRESS"]],
        function: attrs[headerIndex["FUNCTION"]],
        onlChanges: attrs[headerIndex["ONL-CHANGES"]],
        onlChanged:attrs[headerIndex["ONL-CHANGED"]],
        sshPort: attrs[headerIndex["SSH-PORT"]],
      })
    }

    return output;
    return [
      {bqnId: 241, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 242, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 243, ipAddress: '1.1.1.1', function: 'offline'},
      {bqnId: 244, ipAddress: '1.1.1.1', function: 'offline'},
      {bqnId: 245, ipAddress: '1.1.1.1', function: 'offline'},
      {bqnId: 246, ipAddress: '1.1.1.1', function: 'offline'},
      {bqnId: 247, ipAddress: '1.1.1.1', function: 'offline'},
      {bqnId: 248, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 249, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 250, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 252, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 253, ipAddress: '1.1.1.1', function: 'online'},
      /*{bqnId: 254, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 201, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 202, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 203, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 204, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 205, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 206, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 207, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 208, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 209, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 210, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 211, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 212, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 213, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 214, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 215, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 216, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 217, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 218, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 219, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 220, ipAddress: '1.1.1.1', function: 'online'},
      {bqnId: 220, ipAddress: '1.1.1.1', function: 'online'},*/
    ]
  }

/**
 * bqnadm@bqn1# show cluster bqn 
BQN ADDRESS         FUNCTION  ONL-CHANGES              ONL-CHANGED
241 192.168.1.241   primary             1 2025-02-14T12:46:29+0100
242 192.168.1.242   offline             4 2025-02-14T12:52:29+0100
bqnadm@bqn1# show hardware id
BQN SYSTEM-ID       
241 0x5C30411B      
bqnadm@bqn1# show cluster bqn
BQN ADDRESS         FUNCTION  ONL-CHANGES              ONL-CHANGED
241 192.168.1.241   primary             1 2025-02-14T12:46:29+0100
242 192.168.1.242   secondary           6 2025-02-14T12:58:00+0100
bqnadm@bqn1# show hardware id
241 0x5C30411B      
242 0x7E009F75      
bqnadm@bqn1#
 */
export function parseClusterHardwareId(res) {
  if (!res.trim().startsWith("BQN")) {
    res = "BQN SYSTEM-ID\n" + res;
  }

  const output = {};

  parseStrTable(res, (attrs, i) => {
    output[attrs[0]] = attrs[1];
  });

  return output;
}

export function parseVersion(res) {
  const value = res.match(/BQN release: (.*)/);
  if (value) return value[1];
  else return "unknown";
}

export function formatLargeStrNum(valueStr, precision) {
  return Number(valueStr).toLocaleString('en-US',
    { maximumFractionDigits: precision });
}

export function percentOver(value, total) {
  var ratio;

  if (value == 0 || total == 0) {
    return '0 %';
  } else {
    ratio = (value / total);
    return ((ratio > 1.0 ? 1.0 : ratio) * 100).toFixed(1)+' %';
  }
};

export function normalizeUnits(valueStr, units, precision) {
  var num = Number(valueStr);
  if (units == 'Mbps' && num > 1000) {
    units = 'Gbps';
    num /= 1000;
  }
  return num.toFixed(precision)+' '+units;
};

export const getBqnIdCmdPart = (mode, bqnId) => mode === "standalone" || bqnId === "all" || bqnId === undefined ? "" : ` bqn-id ${bqnId}`;

export const getQuantileStats = (values, custom) => {
  const sortedValues = [...values].sort(function (a, b) {
    return a - b;
  });
  const q1 = d3.quantile(sortedValues, 0.25);
  const median = d3.quantile(sortedValues, 0.5);
  const q3 = d3.quantile(sortedValues, 0.75);
  const min = sortedValues.at(0);
  const max = sortedValues.at(-1);
  const p10 = d3.quantile(sortedValues, 0.1);
  const p90 = d3.quantile(sortedValues, 0.9);
  return { q1, median, q3, min, max, p10, p90 ,  ...(custom!== undefined ? {pcustom: d3.quantile(sortedValues, custom)} : {})};
};

export const groupBy = (field, list, {defaults}={}) =>
  list.reduce(
    (result, { [field]: key, ...item }) => ({
      ...result,
      [key !== undefined ? key : defaults]: [
        ...(result[key] || [/*not found*/]),
        item,
      ],
    }),
    {}
  );

const onlineOnes = item =>
  item['function'] !== 'offline';

export const retrieveClusterBqns = () =>
  ifCl.run("show cluster bqn")

export const requestOnlineBqnIds = () =>
  retrieveClusterBqns()
    .then(parseShowClusterBqn)
    .then(list => list.filter(onlineOnes).map( ({bqnId}) => bqnId));

export function getProfiles(){
  return ifCl.run("show profile").then((response) => {
    const [header, ...lines] = response.trim().split("\n");
    return lines.map((line)=>{
        const [profile] = line.split(/\s+/);
        return profile;
    });
  });
};

export const getPoliciesInRules = (response, type) => {
  const lines = response.trim().split("\n");
  const rules = lines.reduce((acc, line) => {
    if (line.startsWith(`rule ${type}`)) {
      const parts = line.split("policy ");
      if (parts.length > 1) {
        acc.push(parts[1]);
      }
    }
    return acc;
  }, []);
  return rules;
};
